module.exports = {
    menu: {
        index:'首页',
        brand: '品牌矩阵',
        investor: '投资者关系',
        news: '新闻动态',
        hr: '人才招聘',
        serveice: '投诉与建议'
    },
    brand: {
        hla: '海澜之家',
        hla_heans: '黑鲸',
        ovv: 'OVV',
        heylads: '男生女生',
        yeehoo: '英氏',
        sancanal: '圣凯诺',
        hla_home: '海澜优选',
        hla_f2c: '海澜团购定制'
    },
    aside: {
        stock: '股票信息',
        name: '股价行情'
    },
    shopname:'官方商城',
    shoplink:'官方网站',
    top:'回到顶部',
    more: '查看更多',
    text: '正文',
    news_detail: '新闻详情',
    temporary_announcement: '临时公告',
    regular_announcement: '定期公告',
    board_of_directors:'董事会',
    board_of_supervisors: '监事会',
    other_executives:'其他高管',
    privacy_policy: '隐私政策'
}


// WEBPACK FOOTER //
// ./src/lang/zh.js